export default (value, n = 2) => {
  if(!value){
    return value
  }
  let money = parseFloat((value + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
  let a = money.split(".")[0].split("").reverse();
  let b = money.split(".")[1];
  let c = '';
  for (let i = 0; i < a.length; i++) {
    c += a[i] + ((i + 1) % 3 === 0 && (i + 1) !== a.length ? "," : "");
  }
  return c.split("").reverse().join("") + "." + b;
}



// WEBPACK FOOTER //
// ./src/static/js/utils/modules/formMoney.js